import { useEffect, useState } from 'react';

const suppressedSources = new Set<string>();
const subscribers = new Set<() => void>();

function emitShellChromeChange(): void {
  for (const subscriber of subscribers) subscriber();
}

export function isShellChromeSuppressed(): boolean {
  return suppressedSources.size > 0;
}

export function setShellChromeSuppressed(source: string, suppressed: boolean): void {
  const before = isShellChromeSuppressed();
  if (suppressed) {
    suppressedSources.add(source);
  } else {
    suppressedSources.delete(source);
  }
  if (before !== isShellChromeSuppressed()) emitShellChromeChange();
}

export function subscribeShellChromeSuppression(subscriber: () => void): () => void {
  subscribers.add(subscriber);
  return () => subscribers.delete(subscriber);
}

export function useShellChromeSuppressed(): boolean {
  const [suppressed, setSuppressed] = useState(isShellChromeSuppressed);

  useEffect(
    () =>
      subscribeShellChromeSuppression(() => {
        setSuppressed(isShellChromeSuppressed());
      }),
    [],
  );

  return suppressed;
}

export function resetShellChromeSuppressionForTests(): void {
  if (suppressedSources.size === 0) return;
  suppressedSources.clear();
  emitShellChromeChange();
}
